import {
    VIRTUAL_APPOINTMENT_TEAMS,
    type VirtualAppointmentTeam
} from '../../services/virtualAppointments';
import { SegmentedToggle, type SegmentedOption } from './SegmentedToggle';
import { teamSegmentOption } from './teamSegmentOptions';

const TEAM_OPTIONS: readonly SegmentedOption<VirtualAppointmentTeam>[] =
    VIRTUAL_APPOINTMENT_TEAMS.map((team) => teamSegmentOption(team, team));

interface VirtualAppointmentTeamSelectorProps {
    value: VirtualAppointmentTeam;
    onChange: (team: VirtualAppointmentTeam) => void;
    disabled?: boolean;
}

export function VirtualAppointmentTeamSelector({
    value,
    onChange,
    disabled = false
}: VirtualAppointmentTeamSelectorProps) {
    const select = (next: VirtualAppointmentTeam) => {
        if (next !== value) onChange(next);
    };
    return (
        <SegmentedToggle<VirtualAppointmentTeam>
            value={value}
            options={TEAM_OPTIONS}
            onChange={select}
            ariaLabel="Team"
            disabled={disabled}
        />
    );
}
